import useQueryParentLayer from "../chain/store/useStoreLayerParent";
import { useQueryPathsByOriginalSource } from "../chain/store/useStorePathByLayer";
import { useQueryOriginSource } from "../chain/useQueryOriginal";
import useLogStack from "./useLogStack";

/**
 *  When a layer make a change, it will call to sub layer to update so there many emit change on useOnLayerAfterSet.
 *  This class use to make sure only 1 times change will be emitted */

const layerChangings = new Set();

window['layerChangings'] = layerChangings;

const callbackDones = [];

const useChangeBox = (layer, propertyPath, key, value, oldValue) => {
    useLogStack('useChangeBox - BEGIN', layer, { key, value, })
    layerChangings.add(layer);
    const originalSource = useQueryOriginSource(layer);
    let layerPaths;
    if (originalSource) {
        layerPaths = useQueryPathsByOriginalSource(originalSource);
    }

    const endChange = () => {
        layerChangings.delete(layer);

        if (layerChangings.size > 0) return;
        if (!layerPaths) return
        layerPaths.forEach((paths, layer) => {
            if (paths.isSpecialPath) return;
            paths = paths.clone();
            paths.push(key);
            for (let i in callbackDones) {
                callbackDones[i].call(null, paths, key, value, oldValue);
            }
        })
        useLogStack('useChangeBox - DONE', layer, { propertyPath, key, value, })
    }

    return endChange;
}

export const onChangeBoxDone = (cb) => {
    if (typeof cb !== 'function') return;
    callbackDones.push(cb);
}

export default useChangeBox